import React from 'react';
import { Smartphone } from 'lucide-react';

const ACCENT = '#3fced1';

/** App-Download Call-to-Action – Port der Flutter app_download_cta_section. */
const AppDownloadCta: React.FC = () => {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
      <div className="relative overflow-hidden rounded-3xl border border-zinc-800 bg-zinc-900 p-8 shadow-xl shadow-black/20 sm:p-12">
        {/* Akzent-Glow (funktioniert in Dark & Light) */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              'radial-gradient(80% 120% at 0% 0%, rgba(63,206,209,0.18), transparent 60%)',
          }}
        />
        <div className="relative flex flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
          <div className="max-w-xl">
            <div
              className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-2xl"
              style={{ backgroundColor: 'rgba(63,206,209,0.12)', color: ACCENT }}
            >
              <Smartphone size={26} />
            </div>
            <h2 className="text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Hol dir die <span className="accent-gradient-text">DartCloud App</span>
            </h2>
            <p className="mt-2 text-gray-400">
              Turniere, Live-Scores, Statistiken & mehr – immer dabei auf deinem Smartphone.
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href="https://apps.apple.com/app/dartcloud"
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-zinc-700 bg-black px-5 py-3 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:border-[#3fced1]/60"
            >
              App Store
            </a>
            <a
              href="https://play.google.com/store/apps"
              target="_blank"
              rel="noreferrer"
              className="rounded-xl px-5 py-3 text-sm font-semibold text-black shadow-lg shadow-[#3fced1]/25 transition-all hover:-translate-y-0.5 hover:opacity-90"
              style={{ backgroundColor: ACCENT }}
            >
              Google Play
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDownloadCta;
